import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import "./App.css";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaClock,
  FaBars,
  FaTimes,
} from "react-icons/fa";

const Contact = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  // Scroll header effect
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Prevent body scroll when menu is open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "auto";
  }, [menuOpen]);

  return (
    <div className="about-page">
      {/* ✅ SEO Meta Data */}
      <Helmet>
        <title>
          Contact Ashtavinayak Children’s Hospital & Critical Care | Sambhajinagar
        </title>
        <meta
          name="description"
          content="Get in touch with Ashtavinayak Children’s Hospital & Critical Care, Sambhajinagar — the trusted pediatric & gynecology hospital providing 24x7 emergency care for children and mothers."
        />
        <meta
          name="keywords"
          content="Ashtavinayak hospital contact, pediatric hospital Sambhajinagar, children hospital, gynecology hospital, emergency hospital, critical care Sambhajinagar"
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.ashtavinayakhospital.in/contact" />

        {/* Open Graph (for Facebook, WhatsApp, etc.) */}
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Contact Ashtavinayak Children’s Hospital & Critical Care | Sambhajinagar"
        />
        <meta
          property="og:description"
          content="Reach Ashtavinayak Children’s Hospital for pediatric and maternity care — available 24x7 for emergency needs."
        />
        <meta property="og:image" content="/logo.png" />
        <meta
          property="og:url"
          content="https://www.ashtavinayakhospital.in/contact"
        />
        <meta property="og:site_name" content="Ashtavinayak Children's Hospital" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Contact Ashtavinayak Children’s Hospital & Critical Care"
        />
        <meta
          name="twitter:description"
          content="24x7 children and maternity hospital in Sambhajinagar with top pediatricians and gynecologists."
        />
        <meta name="twitter:image" content="/logo.png" />
      </Helmet>

      {/* ===== Transparent Navbar ===== */}
      <header
        className={`main-header ${isScrolled ? "scrolled" : ""}`}
        style={{
          zIndex: 5000,
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
        }}
      >
        <div className="navbar-container">
          <a href="/" className="navbar-logo">
            <img
              src="/logo.png"
              alt="Ashtavinayak Children's Hospital & Critical Care"
            />
          </a>

          <nav
            className={`nav-links ${menuOpen ? "active" : ""}`}
            style={{ zIndex: 6000, position: menuOpen ? "fixed" : "" }}
          >
            <a href="/" onClick={() => setMenuOpen(false)}>Home</a>
            <a href="/about" onClick={() => setMenuOpen(false)}>About Us</a>
            <a href="/facilities" onClick={() => setMenuOpen(false)}>Facilities</a>
            <a href="/contact" onClick={() => setMenuOpen(false)}>Contact</a>
          </nav>

          <button
            className="menu-toggle"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle Menu"
          >
            {menuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </header>

      {/* ===== Hero Section ===== */}
      <section className="about-hero">
        <div className="hero-overlay">
          <div className="about-hero-content">
            <h1>Contact Ashtavinayak Children's Hospital & Critical Care</h1>
            <p>
              Providing exceptional child healthcare with compassion,
              innovation, and trust — shaping brighter, healthier beginnings for every family.
            </p>
          </div>
        </div>
      </section>

      <div style={{ height: "60px" }}></div>

      {/* ===== Contact Info ===== */}
      <section className="contact-hero">
        <div className="contact-overlay">
          <div className="contact-container">
            <div className="contact-info">
              <h2>Feel Free to Contact Us</h2>
              <p>
                Ashtavinayak Children's Hospital & Critical Care offers advanced pediatric and gynecology care in Sambhajinagar.
                Our team ensures the well-being of every child and mother through expertise and compassion.
              </p>

              <div className="contact-details">
                <p><FaMapMarkerAlt /> KT Complex, beside Savitri Lawns, Sambhajinagar, India-431002</p>
                <p><FaPhoneAlt /> +91 8149492473</p>
                <p><FaClock /> Monday to Sunday: All Days</p>
                <p><FaEnvelope /> ashtavinayakhospital@gmail.com</p>
              </div>

              <h3>Need emergency?</h3>
              <p>We’re available 24x7 for urgent medical needs.</p>
            </div>
          </div>
        </div>
      </section>

      <a href="tel:+918149492473" className="sticky-call-btn">
        <FaPhoneAlt className="call-icon" />
        <span>Call Us Now</span>
      </a>

      {/* ===== Footer ===== */}
      <footer className="footer-section">
        <div className="footer-container">
          <div className="footer-about">
            <img
              src="/logo.png"
              alt="Ashtavinayak Children's Hospital & Critical Care"
              className="footer-logo"
            />
            <p>
              Dedicated to providing compassionate, high-quality healthcare for children and mothers in Sambhajinagar.
            </p>
          </div>

          <div className="footer-links">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/about">About Us</a></li>
              <li><a href="/facilities">Facilities</a></li>
              <li><a href="/contact">Contact</a></li>
            </ul>
          </div>

          <div className="footer-contact">
            <h4>Contact Us</h4>
           <p> Ashtvinayak hospital, KT complex, beside savitri lawns, Sambhajinagar, India-431002     </p>
      <p><a href="tel:+918149492473" className="contact-link"><FaPhoneAlt /> +91 8149492473</a></p>
            <p><a href="mailto:ashtavinayakhospital@gmail.com" className="contact-link"><FaEnvelope /> ashtavinayakhospital@gmail.com</a></p>
          </div>
        </div>

        <div className="footer-bottom">
          <p>
            © {new Date().getFullYear()} Ashtavinayak Children's Hospital & Critical Care. All Rights Reserved.
            <br />
            <span className="developer-text">
              Designed & Developed by{" "}
              <a href="https://intelligicsoftware.in" target="_blank" rel="noopener noreferrer">
                Intelligic Software Pvt. Ltd.
              </a>
            </span>
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Contact;
